export const getConsoleStyle = (params) => {
    return `color: #697a8b; ${params?.isBold ? 'font-weight: 800' : ''}`;
};
